import { API_BASE_URL } from '@/constants/api'

export interface TrashItem {
  id: string
  shareName: string
  fileName: string
  deletedAt: string
  cleanupTime: string
}

export interface TrashListResponse {
  items: TrashItem[]
  total: number
  page: number
  pageSize: number
  totalPages: number
}

interface ErrorResponse {
  error?: string
  message?: string
}

function getAuthToken(): string {
  const token = localStorage.getItem('accessToken')
  if (!token) {
    throw new Error('未登录')
  }
  return token
}

export async function getTrashItems(page = 1, pageSize = 50): Promise<TrashListResponse> {
  const token = getAuthToken()

  const response = await fetch(`${API_BASE_URL}/trash/items?page=${page}&pageSize=${pageSize}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`,
    },
  })

  if (!response.ok) {
    let message = '获取回收站列表失败'
    try {
      const error: ErrorResponse = await response.json()
      if (error.error || error.message) {
        message = error.error || error.message!
      }
    } catch {
      // ignore
    }
    throw new Error(message)
  }

  return response.json()
}

export async function deleteTrashItem(shareId: string): Promise<void> {
  const token = getAuthToken()

  const response = await fetch(`${API_BASE_URL}/trash/items/${shareId}`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`,
    },
  })

  if (!response.ok) {
    let message = '删除失败'
    try {
      const error: ErrorResponse = await response.json()
      if (error.error || error.message) {
        message = error.error || error.message!
      }
    } catch {
      // ignore
    }
    throw new Error(message)
  }
}

export async function clearTrash(): Promise<void> {
  const token = getAuthToken()

  const response = await fetch(`${API_BASE_URL}/trash/clear`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`,
    },
  })

  if (!response.ok) {
    let message = '清空回收站失败'
    try {
      const error: ErrorResponse = await response.json()
      if (error.error || error.message) {
        message = error.error || error.message!
      }
    } catch {
      // ignore
    }
    throw new Error(message)
  }
}
